/* eslint-disable max-len */
import { useMutation } from '@apollo/client';
import React, { useState } from 'react';
import AdminModal from '../../../components/AdminModal';
import TextInput from '../../../components/input';
import SelectSearch from '../../../components/SelectSearch';
import useForm from '../../../customHooks/useForm';
import useToast from '../../../customHooks/useToast';
import { ADMIN_GENERATE_REALTOR_CODE } from '../../../graphql/admin_mutations';
import InfoIconNew from '../../../svgs/InfoIconNew';
import Styles from './GenerateRealtorTrackingCode.module.scss';

interface IGenerateRealtorTrackingCodeModal{
  closeModal:any;
  refetch:any;
}
const GenerateRealtorTrackingCodeModal = ({ closeModal, refetch }:IGenerateRealtorTrackingCodeModal) => {
  const Toast = useToast();
  const [showSuccessModalState, setShowSuccessModalState] = useState(false);
  const [createPropertyAgentRequest, { loading: createPropertyAgentLoading }] = useMutation<
  { createPropertyAgent: any },
  any
>(ADMIN_GENERATE_REALTOR_CODE);
  const [country, setCountry] = useState('');
  const {
    formValues, handleChange, resetForm,
  } = useForm(
    {
      firstName: '',
      lastName: '',
      email: '',
    },
    {},
    Toast,
  );

  const handleSubmit = async () => {
    if (!formValues?.firstName || !formValues?.lastName || !formValues?.email || !country) {
      return Toast.error('All fields are required');
    }

    const variables = {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      email: formValues?.email,
      country,
    };

    if (!createPropertyAgentLoading) {
      try {
        const res = await createPropertyAgentRequest({ variables });

        if (
          res?.data?.createPropertyAgent
          && res?.data?.createPropertyAgent?.status === 200
        ) {
          refetch?.();
          resetForm();
          setShowSuccessModalState(true);
        } else {
          setShowSuccessModalState(false);
          Toast.error(res?.data?.createPropertyAgent?.message || 'Operation Failed');
        }
      } catch (e: any) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div className={Styles.wrapper}>
      <AdminModal
        headText={showSuccessModalState ? 'Code Generated Successfully!' : 'Generate Tracking Code'}
        subText={showSuccessModalState ? (
          <div className={Styles.wrapper__subtitle}>
            You have successfully generated a tracking code for
            {' '}
            <span>{`${formValues?.firstName} ${formValues?.lastName}`}</span>
            , the user will be informed and it will be reflected on their dashboard.
          </div>
        ) : 'Kindly provide the details below to generate tracking code for a realtor.'}
        actionBtnName="generate code"
        handleModalAction={handleSubmit}
        topIcon={<InfoIconNew />}
        isShow
        isSuccess={showSuccessModalState}
        isActionBtnDisabled={createPropertyAgentLoading}
        onClickAway={() => {}}
        onClose={closeModal}
        isLoading={createPropertyAgentLoading}
      >
        {
          !showSuccessModalState && (
          <div>
            <div>
              <TextInput
                name="firstName"
                value={formValues?.firstName}
                label="Realtor first name"
                isRequired
                customOnChange={handleChange}
                backgroundColor="rgba(255, 255, 255, 1)"
              />
            </div>
            <div>
              <TextInput
                name="lastName"
                value={formValues?.lastName}
                label="Realtor last name"
                isRequired
                customOnChange={handleChange}
                backgroundColor="rgba(255, 255, 255, 1)"
              />
            </div>
            <div>
              <TextInput
                name="email"
                value={formValues?.email}
                label="Email address of Realtor"
                isRequired
                customOnChange={handleChange}
                backgroundColor="rgba(255, 255, 255, 1)"
              />
            </div>
            <div>
              <SelectSearch
                label=""
                options={[
                  { label: 'Canada', value: 'Canada' },
                  { label: 'USA', value: 'usa' },
                ]}
                placeholder="Select Country"
                name="Select Country"
                value={country}
                classes={false}
                isRequired
                hideLabel
                onChange={(e) => setCountry(e?.target?.value)}
                disabled={false}
              />
            </div>
          </div>
          )
        }

      </AdminModal>
    </div>

  );
};

export default GenerateRealtorTrackingCodeModal;
